var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBymTrafikklys(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32",
    width: 32,
    height: 32,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h32v32H0z"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(8 1)"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeWidth: 2,
    d: "M5 0h6v17H5z"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "currentColor",
    fillRule: "nonzero",
    cx: 8,
    cy: 13.5,
    r: 1.5
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "currentColor",
    fillRule: "nonzero",
    cx: 8,
    cy: 8.5,
    r: 1.5
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "currentColor",
    fillRule: "nonzero",
    cx: 8,
    cy: 3.5,
    r: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeWidth: 2,
    d: "M3 14v-2H1zM12.911 14v-2h2zM3 9V7H1zM12.911 9V7h2zM3 4V2H1zM12.911 4V2h2zM8 17v13M3 28h10"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    d: "M22 30H0"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBymTrafikklys);
export default __webpack_public_path__ + "static/media/BYM_trafikklys.f824e599.svg";
export { ForwardRef as ReactComponent };